import React from "react";
import MultiSelect from "../../../components/MultiSelect";

export const BANKS = [
  { value: "BUNQ", label: "Bunq" },
  { value: "BNP", label: "Bnp" },
  { value: "BUNQ_LESTUD", label: "Le stud" },
  { value: "QONTO_LECOLLECTIF", label: "Qonto Le Collectif" },
  { value: "QONTO_SELEGO", label: "Qonto Selego" },
  { value: "QONTO_WALEGO", label: "Qonto Walego" },
  { value: "RAIFFEISEN_KONSTRUKT", label: "Raiffeisen Konstrukt" },
];

export default ({ values = [], onChange }) => {
  return <MultiSelect values={values} id="select-banks" options={BANKS} onSelectedChange={onChange} placeholder="Select a bank" />;
};
